import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { AddressTypeEnum } from '../adress.enum';

const useDefaultAddressType = (name: string) => {
  const { getValues, setValue } = useFormContext();

  useEffect(() => {
    const fieldName = `${name}.type`;
    if (!getValues(fieldName)) {
      setValue(fieldName, AddressTypeEnum.DELIVERY);
    }
  }, [name, getValues, setValue]);
};

export default useDefaultAddressType;
